import  './index'
import axios from '@/http/axios'

async function getOnboarding () {
  const token = localStorage.accessToken
  
  return axios.get('/api/onboardings', {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function getOnboardingById (payload) {
  const token = localStorage.accessToken
  
  return axios.get(`/api/onboardings/${payload.formId}`, {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function getOnboardings () {
  const token = localStorage.accessToken
  
  return axios.get('/api/onboardings/list', {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function saveOnboarding (payload) {
  const token = localStorage.accessToken
  
  return axios.post('/api/onboardings', payload, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
export {
  getOnboarding, saveOnboarding, getOnboardings, getOnboardingById
}
